import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-step-subdominio',
  templateUrl: './step-subdominio.component.html',
  styleUrls: ['./step-subdominio.component.scss']
})
export class StepSubdominioComponent implements OnInit {
  @Input() subdominioInicial = '';
  @Input() empresa: any = {};
  @Output() onConcluido = new EventEmitter<string>();
  @Output() onVoltar = new EventEmitter<void>();

  subdominio = '';
  verificando = false;
  disponivel: boolean | null = null;
  erroValidacao: string | null = null;
  shakeSubdominio = false;
  private verificar$ = new Subject<string>();

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.subdominio = this.subdominioInicial;

    this.verificar$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(dominio => {
        this.verificando = true;
        this.disponivel = null;
        return this.http.get<any>(`/api/empresas/valideDominio?d=${dominio}.meucardapio.ai`);
      })
    ).subscribe(
      resp => {
        this.verificando = false;
        // Se a API retorna sucesso, o domínio JÁ EXISTE (não disponível)
        // Se retorna erro, o domínio NÃO existe (disponível)
        this.disponivel = !resp.sucesso;
      },
      () => {
        this.verificando = false;
        this.disponivel = true; // Se deu erro na request, provavelmente está disponível
      }
    );

    if (this.subdominio) {
      this.verificar$.next(this.subdominio);
    }
  }

  onDigitar() {
    this.subdominio = this.slugify(this.subdominio);
    if (this.subdominio.length >= 3) {
      this.verificar$.next(this.subdominio);
    } else {
      this.disponivel = null;
    }
  }

  podeAvancar(): boolean {
    return this.subdominio.length >= 3 && this.disponivel === true;
  }

  avancar() {
    if (this.subdominio.length < 3) {
      this.erroValidacao = 'Digite ao menos 3 caracteres para o endereço.';
      this.triggerShakeSubdominio();
      return;
    }
    if (this.verificando) {
      this.erroValidacao = 'Aguarde a verificação do endereço.';
      this.triggerShakeSubdominio();
      return;
    }
    if (this.disponivel === false) {
      this.erroValidacao = 'Este endereço já está em uso. Tente outro.';
      this.triggerShakeSubdominio();
      return;
    }
    this.erroValidacao = null;
    this.onConcluido.emit(this.subdominio);
  }

  private triggerShakeSubdominio() {
    this.shakeSubdominio = true;
    setTimeout(() => this.shakeSubdominio = false, 600);
  }

  voltar() {
    this.onVoltar.emit();
  }

  private slugify(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]/g, '')
      .substring(0, 30);
  }
}
